import translationsEn from "./en";

export const resources = {
    en: { translation: translationsEn },
};
